import angular from 'angular'

import modalDetailCtrl from './modalDetailCtrl'
import invoiceTitleModalCtrl from '../invoice1/invoiceTitleModalCtrl'

import { eleInvoice, invoice, ovatBill } from 'redevConfig'

const list = (eleInvoice && eleInvoice.list) || ''

const addScan = (eleInvoice && eleInvoice.addScan) || ''
const printView = (eleInvoice && eleInvoice.printView) || ''

const invoiceDetail = (invoice && invoice.detail) || ''
const invoiceAdd = (invoice && invoice.add) || ''
const relatedBill = (invoice && invoice.relatedBill) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''

// checkBillDetail *************************
const listPage = list ? require(`redevelopment/outputManage/eleInvoice/${list.templateName}`) : require('./view/list.html')
const listCtrl = list ? require(`redevelopment/outputManage/eleInvoice/${list.controllerName}`) : require('./list')

const detailPage = invoiceDetail ? require(`redevelopment/outputManage/invoice/${invoiceDetail.templateName}`) : require('../invoice1/view/invoiceDetail.html')

const editPage = invoiceAdd ? require(`redevelopment/outputManage/invoice/${invoiceAdd.templateName}`) : require('../invoice1/view/invoiceEdit.html')

const relatedBillPage = relatedBill ? require(`redevelopment/outputManage/invoice/${relatedBill.templateName}`) : require('../invoice1/view/relatedBill_invoice.html')

const scanEditCtrl = addScan ? require(`redevelopment/outputManage/eleInvoice/${addScan.controllerName}`).default : require('./edit').default
const scanEditPage = addScan ? require(`redevelopment/outputManage/eleInvoice/${addScan.templateName}`) : require('./view/edit.html')

const printViewCtrl = printView ? require(`redevelopment/outputManage/eleInvoice/${printView.controllerName}`).default : require('./printViewCtrl').default
const printViewPage = printView ? require(`redevelopment/outputManage/eleInvoice/${printView.templateName}`) : require('./view/printView.html')

const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('../ovatBill/view/checkBillDetailCtrl.html')

function configRouter ($stateProvider) {
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice',
        {
            url: '/eleInvoice',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'outputManage.FOManage.eleInvoice.list',
            title: '电子票开具',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.list',
        {
            url: '/list',
            template: listPage,
            controller: 'eleInvoiceListCtrl',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.detail',
        {
            url: '/detail/:waitId',
            template: detailPage,
            controller: 'invoiceEditCtrl',
            title: '电子票详情',
            params: {
                detailFlag: true,
            },
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.edit',
        {
            url: '/eidt/:waitId',
            template: editPage,
            controller: 'invoiceEditCtrl',
            title: '编辑电子票',
            params: {
                pagingFlag: true,
            },
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.add',
        {
            url: '/add/:invType',
            template: editPage,
            controller: 'invoiceEditCtrl',
            title: '新增电子票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.addred',
        {
            url: '/addred/:invType',
            template: editPage,
            controller: 'invoiceEditCtrl',
            title: '新增红字电子票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.relatedBill',
        {
            url: '/relatedBill/:waitId',
            template: relatedBillPage,
            controller: 'invRelatedBillCtrl',
            title: '电子票销售单',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.checkBillDetail',
        {
            url: '/checkBillDetail/:billId',
            template: checkBillDetailCtrl,
            controller: 'checkBillDetailCtrl',
            title: '销售单明细',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.addScan',
        {
            url: '/addScan/:invType',
            template: scanEditPage,
            controller: scanEditCtrl,
            title: '新增扫码开票',
        },
    )
    $stateProvider.state(
        'outputManage.FOManage.eleInvoice.printView',
        {
            url: '/printView/:waitIds/:batchNo',
            template: printViewPage,
            controller: printViewCtrl,
            title: '二维码开票预览',
        },
    )
}

export default angular
    .module('outputManage.FOManage.eleInvoice', [])
    .config(['$stateProvider', configRouter])
    .controller('eleInvoiceListCtrl', listCtrl.default)
    .controller('scanEditCtrl', scanEditCtrl)
    .controller('printViewCtrl', printViewCtrl)
    .controller('modalDetailCtrl', modalDetailCtrl)
    .controller('invoiceTitleModalCtrl', invoiceTitleModalCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/eleInvoice/index.js